import { useRef, useState, useEffect } from "react";

export default function CameraCapture({ onChangeFoto }) {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [foto, setFoto] = useState(null); // continua como preview base64
    const [file, setFile] = useState(null); // continua como preview base64

    async function startCamera() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" }, // câmera traseira
            });

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
        } catch (err) {
            console.error("Erro ao acessar a câmera:", err);
        }
    }

    useEffect(() => {
        startCamera();
    }, []);

    const tirarFoto = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (!video || !canvas) return;

        const ctx = canvas.getContext("2d");

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // base64 apenas para exibir preview
        const imagemBase64 = canvas.toDataURL("image/png");
        setFoto(imagemBase64);

        // aqui convertemos em File
        canvas.toBlob((blob) => {
            if (blob) {
                const file = new File([blob], `foto_${Date.now()}.png`, {
                    type: "image/png",
                });
                setFile(file)
            }
        }, "image/png");
    };

    return (
        <div style={{ padding: 20 }}>
            <h2>Capturar Foto</h2>

            {/* Vídeo da câmera */}
            {!foto && (
                <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    style={{ width: "100%", borderRadius: 8 }}
                />
            )}

            {!foto && (
                <button
                    onClick={tirarFoto}
                    style={{
                        width: "100%",
                        marginTop: 10,
                        padding: "10px 20px",
                        background: "#2563eb",
                        color: "white",
                        borderRadius: 8,
                    }}
                >
                    Tirar Foto
                </button>
            )}

            {foto && (
                <div className="flex items-center justify-center gap-2">
                    <button
                        onClick={() => { setFoto(null); startCamera() }}
                        style={{
                            width: "100%",
                            marginTop: 10,
                            padding: "10px 20px",
                            background: "#2563eb",
                            color: "white",
                            borderRadius: 8,
                        }}
                    >
                        Tirar Outra
                    </button>

                    <button
                        onClick={() => {
                            onChangeFoto(file);
                            setFoto(null);
                            setFile(null);
                        }}
                        style={{
                            width: "100%",
                            marginTop: 10,
                            padding: "10px 20px",
                            background: "#103c99ff",
                            color: "white",
                            borderRadius: 8,
                        }}
                    >
                        Usar essa
                    </button>
                </div>
            )}

            {/* Canvas escondido */}
            <canvas ref={canvasRef} style={{ display: "none" }} />

            {foto && (
                <div style={{ marginTop: 20 }}>
                    <h3>Foto capturada:</h3>
                    <img
                        src={foto}
                        alt="Foto capturada"
                        style={{ width: "100%", borderRadius: 8 }}
                    />
                </div>
            )}
        </div>
    );
}
